import React, { useState } from 'react';
import { Box, TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import './PinInput.css';

interface PinInputProps {
  pin: string;
  verifyPin: string;
  onPinChange: (value: string) => void;
  onVerifyPinChange: (value: string) => void;
  isLoading: boolean;
  showLabels?: boolean;
  placeholder?: string;
  verifyPlaceholder?: string;
}

const PinInput: React.FC<PinInputProps> = ({
  pin,
  verifyPin,
  onPinChange,
  onVerifyPinChange,
  isLoading,
  showLabels = false,
  placeholder = "Enter 6-digit PIN",
  verifyPlaceholder = "Confirm 6-digit PIN"
}) => {
  const [showPin, setShowPin] = useState(false);
  const [showVerifyPin, setShowVerifyPin] = useState(false);

  const handlePinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    onPinChange(value);
  };

  const handleVerifyPinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    onVerifyPinChange(value);
  };

  const inputProps = { maxLength: 6 };

  return (
    <Box className="pin-input">
      <TextField
        className="pin-input-field"
        fullWidth
        type={showPin ? "text" : "password"}
        placeholder={placeholder}
        label={showLabels ? "Enter 6-digit PIN" : undefined}
        variant="outlined"
        value={pin}
        onChange={handlePinChange}
        disabled={isLoading}
        margin={showLabels ? "normal" : undefined}
        InputProps={{
          inputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                className="pin-input-toggle"
                onClick={() => setShowPin(!showPin)}
                edge="end"
                disabled={isLoading}
              >
                {showPin ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <TextField
        className="pin-input-field"
        fullWidth
        type={showVerifyPin ? "text" : "password"}
        placeholder={verifyPlaceholder}
        label={showLabels ? "Confirm 6-digit PIN" : undefined}
        variant="outlined"
        value={verifyPin}
        onChange={handleVerifyPinChange}
        disabled={isLoading}
        margin={showLabels ? "normal" : undefined}
        InputProps={{
          inputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                className="pin-input-toggle"
                onClick={() => setShowVerifyPin(!showVerifyPin)}
                edge="end"
                disabled={isLoading}
              >
                {showVerifyPin ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default PinInput; 